<template>
  <div>
    <h2 class="section__title">{{ text }}</h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { convertTime24to12, formatDate } from '@/helpers'

export default {
  name: 'order-rescheduled',
  computed: {
    ...mapGetters(['orderData']),
    text() {
      let text = `${this.$t('main-page.delivering.not-confirmed.statuses.rescheduled')} `
      text += formatDate(this.orderData.deliver.date)
      if (this.orderData.deliver?.from && this.orderData.deliver?.to) {
        text += ` ${convertTime24to12(this.orderData.deliver.from)} - ${convertTime24to12(this.orderData.deliver.to)}`
      }

      return text
    },
  },
}
</script>
